<div class="flex h-full">
  <!-- Sidebar -->
  <div class="w-56 bg-white dark:bg-slate-900 rounded-tr-3xl rounded-bl-3xl h-[92vh] overflow-y-auto shadow-lg">
    <!-- Title -->
    <h2 class="text-xl font-semibold p-4 border-b border-gray-200 dark:border-gray-700">
      Reports
    </h2>

    <!-- Menu -->
    <ul class="space-y-3 p-2">
      <li
        *ngFor="let tab of reportTabs; let i = index"
        (click)="handleTabClick(i)"
        class="flex items-center gap-3 cursor-pointer px-4 py-2 rounded-lg transition-all duration-200"
        [ngClass]="{
          'bg-blue-600 text-white shadow-md': activeTab === i,
          'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700': activeTab !== i
        }"
      >
        <i [class]="tab.icon"></i>
        <span class="font-medium">{{ tab.name }}</span>
      </li>
    </ul>
  </div>

  <!-- Report Content -->
  <div class="flex-1 bg-gray-50 dark:bg-gray-800 p-6 h-[92vh] overflow-y-auto  shadow-inner">
    
      <app-report-list *ngIf="activeTab === 0"></app-report-list>
      <app-ticket-report-list *ngIf="activeTab === 1"></app-ticket-report-list>
  </div>
</div>

<!-- Floating Configurator -->
<app-floating-configurator></app-floating-configurator>
